import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Redirect } from "react-router";
import useAuth from "../../context/auth.context";

interface PrivateRouteProps {
	children?: any;
}

function PrivateRoute({ children }: PrivateRouteProps) {
	// const { isAuthenticated } = useAuth();
	// const isAuthenticated = useIsAuthenticated();
	// const { inProgress } = useMsal();

	// if(inProgress === InteractionStatus.HandleRedirect) {
	//     return children;
	// }

	// if(inProgress === InteractionStatus.None && !isAuthenticated) {
	//     return <Redirect to={"/signin"} />;
	// }

	// if(!isAuthenticated) {
	// 	return <Redirect to={"/signin"} />;
	// }

	return children;
}

export default PrivateRoute;
